import { ClassUtils } from "../utils/ClassUtils";
import { Skeleton } from "./bone/Skeleton";
import "./TempletLoader";
let c = ClassUtils.regClass;
c("Skeleton", Skeleton);
